import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/admin',
  component: Layout,
  name: 'adminManagement',
  meta: {
    title: '管理员管理',
    icon: 'i-ep:user',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'adminList',
      component: () => import('@/views/admin/index.vue'),
      meta: {
        title: '管理员列表',
        icon: 'i-ep:user',
      },
    },
  ],
}

export default routes
